import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UploaderComponent } from './uploader/uploader.component';

@Component({
  selector: 'frmg-import-files-dialog',
  templateUrl: './import-files-dialog.component.html',
  styleUrls: ['./import-files-dialog.component.scss'],
  imports: [UploaderComponent]
})
export class ImportFilesDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ImportFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      projectId: string;
      folderName: string;
      tenantId?: string;
      teamId?: string;
      userId?: string;
    }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
